import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import useCard from 'client/hooks/useCard';

const SrRenterApplicationStatusStepCard = ({
  cardId,
  title,
  lastSection,
  body,
  disabled,
  completed,
  inProgress,
  rejected,
  defaultExpandedValue,
  previouslyVisited,
}) => {
  const { expanded, setExpanded } = useCard({ id: cardId, defaultExpandedValue });
  let iconImageUrl = null;

  if (rejected) {
    iconImageUrl = '/images/red-x.svg';
  }
  else if (disabled) {
    iconImageUrl = '/images/disabled-circle.svg';
  }
  else if (completed && !inProgress) {
    iconImageUrl = '/images/checkmark-large-green.svg';
  }
  else {
    iconImageUrl = '/images/in-progress-circle-yellow.svg';
  }

  const onToggleCard = () => {
    setExpanded(!expanded);
  };

  return (
    <div className={
      classnames('SrRenterApplicationStatusStepCard', {
        lastSection: lastSection,
        disabled: disabled,
      })
    }
    >
      <div className='titleContainer' onClick={onToggleCard}>
        <div className='title'>
          <img
            className={
              classnames('statusIcon', iconImageUrl ===
              '/images/in-progress-circle-yellow.svg' ? 'statusIconSpin' : null)
            }
            alt='status icon'
            src={iconImageUrl}
          />
          <span className={disabled ? 'disabled' : null}>{title}</span>
          {!disabled && !previouslyVisited && (
            <div className='alertContainer'>
              <div className='alertPulse' />
              <div className='alertIndicator' />
            </div>
          )}
        </div>
        <div
          className={classnames({
            minusIcon: expanded,
            plusIcon: !expanded,
            disabled: disabled,
          })}
        />
      </div>
      <div className={classnames('message', !expanded ? 'hideBody' : null)}>
        {expanded ? body({
          disabled,
          completed,
          inProgress,
        }) : null}
      </div>
    </div>
  );
};

SrRenterApplicationStatusStepCard.propTypes = {
  cardId: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  lastSection: PropTypes.bool,
  body: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
  completed: PropTypes.bool.isRequired,
  inProgress: PropTypes.bool.isRequired,
  defaultExpandedValue: PropTypes.bool,
  previouslyVisited: PropTypes.bool.isRequired,
};

SrRenterApplicationStatusStepCard.displayName = 'SrRenterApplicationStatusStepCard';

export default SrRenterApplicationStatusStepCard;
